import { createStyles } from "../theme";
import { Col, TextLabel } from "../lib";

type Props = {
  title: string | number;
};

export function Badge({ title }: Props) {
  return (
    <Col.C style={$.container}>
      <TextLabel em color="onError">
        {title}
      </TextLabel>
    </Col.C>
  );
}

const $ = createStyles({
  container: {
    backgroundColor: "error",
    width: 22,
    height: 22,
    borderRadius: 11,
  },
});
